
import {buildScale, extendedSinebowColor, fillRange} from "./palette.js";

export function createWindPalette(resolution = 1000) {

    const bounds = [0, 100];  // units: m/s
    const array = new Uint8Array(resolution * 4);
    fillRange(array, [0, 1], [0, 1], extendedSinebowColor);

    return buildScale(bounds, array);

}
